// disclaimer drawer
function ampmDisclaimer() {
  const disclaimerWrapper = $('.ampm--disclaimer-wrapper');
  const disclaimerHeader = $('.ampm--disclaimer-header');
  const disclaimerDrawer = $('.ampm--disclaimer-drawer');
  const drawerClose = $('.ampm--drawer-close');
  const focusableElements = disclaimerDrawer.find('button, a, input, select, textarea');
  const firstFocusable = focusableElements.first();
  const lastFocusable = focusableElements.last();
  const elementsToHide = $(
    // TODO: cleanup this list
    '.skip-nav, .tmgs-2023--headings-wrapper, .navbar, .store-locator, .cravenience-audio--wrapper, .cravenience-video--wrapper, .offers, .scratch-power, footer'
  );

  disclaimerDrawer.hide();

  disclaimerWrapper.click(function(event) {
    if (!$(event.target).hasClass('ampm--drawer-close')) {
      event.stopPropagation();
      if (!$(event.target).hasClass('ampm--disclaimer-drawer') && !$(event.target).closest('.ampm--disclaimer-drawer').length) {
        disclaimerDrawer.slideToggle(300, function() {
          if (disclaimerDrawer.is(':visible')) {
            disclaimerWrapper.attr('aria-label', 'Disclaimer');
            disclaimerHeader.fadeOut(100); 
            elementsToHide.attr('aria-hidden', 'true');
            firstFocusable.focus();
          } else {
            // Close disclaimer
            disclaimerWrapper.attr('aria-label', 'Opens disclaimer content');
            disclaimerHeader.fadeIn(300); 
            elementsToHide.removeAttr('aria-hidden');
            disclaimerHeader.focus();
          }
        });
      }
    }
  });

  drawerClose.click(function() {
    disclaimerDrawer.slideUp(300, function() {
      disclaimerWrapper.attr('aria-label', 'Opens disclaimer content');
      disclaimerHeader.fadeIn(300);  
      elementsToHide.removeAttr('aria-hidden');
      disclaimerHeader.focus();
    });
  });

  firstFocusable.on('keydown', function(e) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastFocusable.focus();
    }
  });

  lastFocusable.on('keydown', function(e) {
    if (e.key === 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstFocusable.focus();
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  if (document.querySelector('.disclaimer-wrapper')) {
    ampmDisclaimer();
  }
});
